import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const Parallax = () => {
    const elements = document.querySelectorAll('[data-parallax]')

    const initParallax = (element) => {
        gsap.registerPlugin(ScrollTrigger)
        gsap.to(element, {
            yPercent: parseFloat(
                element.dataset?.percent || Math.floor(Math.random() * 15)
            ),
            ease: 'none',
            scrollTrigger: {
                trigger: element.closest('.block'),
                scrub: 1,
            },
        })
    }

    elements.forEach(initParallax)

    return true
}

export default Parallax
